
export function getParName(parItem) {
    let name = `${parItem.kmenove_cislo_par}`;
    if (parItem.druh_cislovani_par === '1') {
        name = `St.${name}`;
    }
    if (parItem.poddeleni_cisla_par) {
        name = `${name}/${parItem.poddeleni_cisla_par}`;
    }
    return name;
}
